import React, { Fragment, useState, useRef } from "react";
import CustomLoader from "../../customLoader/CustomLoader";
import GetAdminService from "../../../services/admin/GetAdminService";
import AppHeader from "../../../Layout/AppHeader";
import AppSidebar from "../../../Layout/AppSidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faCheck,
  faSave,
  faTimes,
  faTrash } from
"@fortawesome/free-solid-svg-icons";
import swal from "sweetalert";
import { Modal, ModalBody } from "reactstrap";
import { stateData } from "../../../constants/data";
import "../AdminPages.css";
import "../Student/Student.css";

const MessageModal = ({ isOpen, setIsOpen, data }) => {
  return (
    <Fragment>
      <Modal isOpen={isOpen} centered={true}>
        <ModalBody>
          <div style={{ textAlign: "center" }}>
            <p>{data.message}</p>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <button
                onClick={data.function1}
                style={{
                  backgroundColor: "#009900",
                  color: "white",
                  padding: "5px",
                  border: "none",
                  outline: "none",
                  marginRight: "20px",
                  borderRadius: "5px"
                }}>
                
                <FontAwesomeIcon
                  style={{ margin: "0 5px" }}
                  color="white"
                  icon={faCheck} />
                
                Ok
              </button>
              <button
                onClick={() => setIsOpen(false)}
                style={{
                  backgroundColor: "#efefef",
                  color: "black",
                  padding: "5px",
                  border: "none",
                  outline: "none",
                  marginLeft: "20px",
                  borderRadius: "5px"
                }}>
                
                <FontAwesomeIcon style={{ margin: "0 5px" }} icon={faTimes} />
                Cancel
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>);

};

const Colleges = () => {
  const [collegeName, setCollegeName] = useState();
  const [showCollegeNameContainer, setShowCollegeNameContainer] = useState(
    false
  );
  const [collegeNameList, setCollegeNameList] = useState();
  const collegeNameRef = useRef();
  const timeoutRef = useRef();
  const [collegeNameLoading, setCollegeNameLoading] = useState(false);
  const [modify, setModify] = useState(false);
  const [openCreateCollege, setOpenCreateCollege] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [collegeInput, setCollegeInput] = useState({
    name: "",
    address: "",
    city: "",
    zip_code: "",
    state: "",
    schools: [],
    id: "",
    goal_id: ""
  });

  const [loading, setLoading] = useState(false);

  const [schoolName, setSchoolName] = useState();
  const [showSchoolNameContainer, setShowSchoolNameContainer] = useState(false);
  const [schoolNameList, setSchoolNameList] = useState();
  const schoolNameRef = useRef();
  const [schoolNameLoading, setSchoolNameLoading] = useState(false);
  const [selectedSchool, setSelectedSchool] = useState([]);

  const [defaultGoal, setDefaultGoal] = useState();
  const [showGoalContainer, setShowGoalContainer] = useState(false);
  const [goalList, setGoalList] = useState();
  const [goalLoading, setGoalLoading] = useState();

  const getCollegesList = (value) => {
    setShowCollegeNameContainer(true);
    setCollegeNameLoading(true);
    GetAdminService.getCollegesList(value)
    .then((data) => {
      let collegeData = data?.data?.college;
      let collegeName = collegeData?.map((item) => item.college);
      setCollegeNameList(collegeName);
      setCollegeNameLoading(false);
    })
    .catch((_error) => {
      setCollegeNameLoading(false);
    });
  };








  const getGoalDetail = (value) => {
    setShowGoalContainer(true);
    setGoalLoading(true);
    GetAdminService.getGoalDetail(value)
    .then((data) => {
      setGoalList(data?.data?.goal);
      setGoalLoading(false);
    })
    .catch((_error) => {
      setGoalLoading(false);
    });
  };

  const handleGoal = (value) => {
    setDefaultGoal(value);
    let goalNameSearch = value;
    clearTimeout(timeoutRef.current);
    setShowGoalContainer(true);
    if (!value) {
      setShowGoalContainer(false);
      setGoalList([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getGoalDetail(goalNameSearch);
      }, 1000);
    }
  };

  const handleSelectedGoal = (item) => {
    setDefaultGoal(item?.goal_name);
    setCollegeInput({ ...collegeInput, goal_id: item?.id });
    setShowGoalContainer(false);
    setGoalList([item]);
  };

  const saveCollege = () => {
    let arr = selectedSchool?.map((item) => item.id);
    let obj = {
      name: collegeInput?.name,
      address: collegeInput?.address,
      city: collegeInput?.city,
      zip_code: collegeInput?.zip_code,
      state: collegeInput?.state,
      goal_id: collegeInput?.goal_id
    };
    setLoading(true);
    if (modify) {
      obj.college_id = collegeInput?.id;
      obj.school_id = arr;
      GetAdminService.updateCollege(obj)
      .then((_data) => {
        setLoading(false);
        setNull();
        setOpenCreateCollege(false);
      })
      .catch((_error) => {
        setLoading(false);
      });
    } else {
      obj.school = arr;
      // obj.schools = selectedSchool;
      GetAdminService.saveCollege(obj)
      .then((_data) => {
        setLoading(false);
        setNull();
        setOpenCreateCollege(false);
      })
      .catch((_error) => {
        setLoading(false);
      });
    }
  };

  const setNull = () => {
    setSelectedSchool([]);
    setGoalList([]);
    setDefaultGoal("");
    setModify(false);
    setCollegeInput({
      name: "",
      address: "",
      schools: [],
      id: "",
      city: "",
      zip_code: "",
      state: "",
      goal_id: ""
    });
  };

  const deleteCollege = () => {
    setOpenDeleteModal(false);
    let body = {
      college_id: collegeInput?.id
    };
    setLoading(true);
    GetAdminService.deleteCollege(body)
    .then((_data) => {
      setNull();
      setLoading(false);
      setOpenCreateCollege(false);
      swal({
        text: "College deleted successfully!",
        icon: "success",
        buttons: {
          confirm: true
        },
        closeOnClickOutside: true
      });
    })
    .catch((_error) => {
      setLoading(false);
    });
  };

  const handleCollegeName = () => {
    clearTimeout(timeoutRef.current);
    setCollegeName(collegeNameRef.current.value);
    if (!collegeNameRef.current.value) {
      setShowCollegeNameContainer(false);
      setCollegeNameList([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getCollegesList(collegeNameRef.current.value);
      }, 1000);
    }
  };

  const handleSelectedCollegeName = (item) => {
    setShowCollegeNameContainer(false);
    setCollegeName(item.name);
    setModify(true);
    setOpenCreateCollege(true);
    setCollegeNameList([item]);
    setCollegeInput(item);
    setSelectedSchool(item?.schools);
    setDefaultGoal(item?.goal?.goal_name);
  };

  // useEffect(()=>{
  //   getAllCollegesList();
  // })

  const getSchoolsList = (value) => {
    setSchoolNameLoading(true);
    setShowSchoolNameContainer(true);
    setSchoolNameList([]);
    GetAdminService.getSchoolsListForCollege(value)
    .then((data) => {
      setSchoolNameList(data?.data?.school);
      setSchoolNameLoading(false);
    })
    .catch((_error) => {
      setSchoolNameLoading(false);
    });
  };

  const handleSchoolName = () => {
    clearTimeout(timeoutRef.current);
    setSchoolName(schoolNameRef.current.value);
    if (!schoolNameRef.current.value) {
      setShowSchoolNameContainer(false);
      setSchoolNameList([]);
    } else {
      timeoutRef.current = setTimeout(() => {
        getSchoolsList(schoolNameRef.current.value);
      }, 1000);
    }
  };

  const handleSelectedSchoolName = (item) => {
    setSchoolNameList([item]);
    setSelectedSchool([...selectedSchool, item]);
    setSchoolName("");
    setShowSchoolNameContainer(false);
  };

  const removeSchoolName = (value) => {
    let filteredValue = selectedSchool?.filter((item) => item !== value);
    setSelectedSchool(filteredValue);
  };

  const createCollege =
  <div className="create-student-container">
      <div className="drawer-header">
        <h3 className="drawer-title">
          {modify ? "Modify College" : "New College"}
        </h3>
        <button
        type="button"
        className="drawer-close-btn"
        onClick={() => {
          setOpenCreateCollege(false);
          setNull();
        }}
        aria-label="Close">
        
          <FontAwesomeIcon icon={faTimes} />
        </button>
      </div>

      <div className="drawer-section">
        <div className="drawer-form-row">
          <div className="form-label-col">
            College Name
            <span className="required-marker">*</span>
          </div>
          <div className="form-field-col">
            <input
            type="text"
            placeholder="Enter College Name"
            value={collegeInput.name}
            onChange={(e) =>
            setCollegeInput({ ...collegeInput, name: e.target.value })} />

          
          </div>
        </div>

        <div className="drawer-form-row">
          <div className="form-label-col">Address</div>
          <div className="form-field-col">
            <input
            type="text"
            placeholder="Enter Address First Line"
            value={collegeInput?.address}
            onChange={(e) =>
            setCollegeInput({ ...collegeInput, address: e.target.value })} />

          
          </div>
        </div>

        <div className="drawer-form-row">
          <div className="form-label-col">City</div>
          <div className="form-field-col">
            <input
            type="text"
            placeholder="Enter City"
            value={collegeInput?.city}
            onChange={(e) =>
            setCollegeInput({ ...collegeInput, city: e.target.value })} />

          
          </div>
        </div>

        <div className="drawer-form-row">
          <div className="form-label-col">Zip code</div>
          <div className="form-field-col">
            <input
            type="text"
            placeholder="Enter Zip code"
            value={collegeInput?.zip_code}
            onChange={(e) =>
            setCollegeInput({ ...collegeInput, zip_code: e.target.value })}

            maxLength={6} />
          
          </div>
        </div>

        <div className="drawer-form-row">
          <div className="form-label-col">State</div>
          <div className="form-field-col">
            <select
            value={collegeInput?.state}
            onChange={(e) =>
            setCollegeInput({ ...collegeInput, state: e.target.value })}>

            
              <option disabled selected value="">
                Select State
              </option>
              {stateData.map((item, index) =>
            <option
              style={{ textTransform: "capitalize" }}
              value={item?.name}
              key={index}>
              
                  {item?.name}
                </option>
            )}
            </select>
          </div>
        </div>

        <div className="drawer-form-row">
          <div className="form-label-col">Default Goal</div>
          <div className="form-field-col" style={{ position: "relative" }}>
            <input
            type="text"
            placeholder="Select Default Goal"
            value={defaultGoal}
            onChange={(e) => handleGoal(e.target.value)} />
          
            {showGoalContainer &&
          <ul className="drawer-autocomplete">
                {goalLoading && <CustomLoader />}
                {goalList?.length > 0 &&
            goalList.map((item, index) =>
            <li
              onClick={() => handleSelectedGoal(item)}
              key={index}>
              
                      {item?.goal_name}
                    </li>
            )}
              </ul>}
          
          </div>
        </div>

        <div className="drawer-form-row">
          <div className="form-label-col">Add School</div>
          <div className="form-field-col" style={{ position: "relative" }}>
            <input
            type="text"
            ref={schoolNameRef}
            placeholder="Type the school name"
            value={schoolName}
            onChange={handleSchoolName}
            autoComplete="off" />
          
            {showSchoolNameContainer &&
          <ul className="drawer-autocomplete">
                {schoolNameLoading && <CustomLoader />}
                {schoolNameList?.length > 0 &&
            schoolNameList.map((item, index) =>
            <li
              onClick={() => handleSelectedSchoolName(item)}
              key={index}>
              
                      {item.name}
                    </li>
            )}
              </ul>}
          
          </div>
        </div>

        {selectedSchool?.length > 0 &&
      <div className="drawer-chip-list drawer-chip-list-scroll">
            {selectedSchool.map((item, index) =>
        <div key={item?.id || index} className="drawer-chip">
                <span>{item?.name}</span>
                <FontAwesomeIcon
            icon={faTimes}
            className="chip-remove"
            title="Remove school"
            onClick={() => removeSchoolName(item)} />
          
              </div>
        )}
          </div>}
      
      </div>

      <div className="drawer-footer">
        {modify &&
      <button
        type="button"
        className="drawer-btn-delete"
        onClick={() => setOpenDeleteModal(true)}>
        
            <FontAwesomeIcon icon={faTrash} />
            Delete
          </button>}
      
        <button
        type="button"
        onClick={saveCollege}
        disabled={!collegeInput.name}
        className="drawer-btn-save">
        
          <FontAwesomeIcon icon={faSave} />
          Save
        </button>
      </div>
    </div>;



  return (
    <Fragment>
      <AppHeader />
      <div className="app-main">
        <AppSidebar />
        <div className="app-main__outer">
          <div className="csv-import-container">
            <div className="admin-students-page-header">
              <h2>Colleges</h2>
              <button
                className="admin-students-new-btn"
                onClick={() => setOpenCreateCollege(true)}>
                
                <FontAwesomeIcon icon={faBuilding} />
                New College
              </button>
            </div>

            <div className="admin-students-school-selector">
              <label>Select College</label>
              <div className="school-input-wrapper">
                <input
                  ref={collegeNameRef}
                  type="text"
                  placeholder="Type to search college name..."
                  value={collegeName}
                  onChange={handleCollegeName}
                  autoComplete="off" />
                
                {showCollegeNameContainer &&
                <ul className="school-dropdown">
                    {collegeNameLoading && <CustomLoader />}
                    {collegeNameList?.length > 0 &&
                  collegeNameList.map((item, index) =>
                  <li
                    onClick={() => handleSelectedCollegeName(item)}
                    key={index}>
                    
                          {item.name}
                        </li>
                  )}
                  </ul>}
                
              </div>
            </div>
            {loading &&
            <div className="admin-page-section">
                <CustomLoader />
              </div>}
            
            {openCreateCollege && createCollege}

            {openDeleteModal &&
            <MessageModal
              setIsOpen={setOpenDeleteModal}
              isOpen={openDeleteModal}
              data={{
                function1: deleteCollege,
                message: "Are you sure you want to delete?"
              }} />}

            
          </div>
        </div>
      </div>
    </Fragment>);

};

export default Colleges;